(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["homevisioner-gallery-placement"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.clHomevisionerGalleryPlacement) return;
  window.clHomevisionerGalleryPlacement = true;
  let scheduled = false;
  const place = () => {
    scheduled = false;
    const slot = document.querySelector('[data-section-type="product"] [data-cl-homevisioner-gallery]');
    const widget = document.getElementById('homevisioner-legacy-mount');
    if (!slot || !widget || slot.contains(widget)) return;
    slot.appendChild(widget);
  };
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(place);
  });
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', place);
  place();
})();
  } catch(e) { console.error(e); }
})();

})();
